'use es6';

import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { OrderedSet } from 'immutable';
import { getOptionValue, getOptionLabel } from 'conversations-message-history/quick-reply/operators/quickReplyGetters';
import VizExMobileSelect from 'visitor-ui-component-library/select/VizExMobileSelect';
import { createThemeV2 } from 'visitor-ui-component-library/theme/createThemeV2';
import { jsx as _jsx } from "react/jsx-runtime";
const PLACEHOLDER_VALUE = '__PLACEHOLDER_VALUE__';
const QuickReplySelect = ({
  quickReplyOptions,
  onChange,
  disabled,
  value,
  placeholder,
  theme = createThemeV2()
}) => {
  const options = useMemo(() => quickReplyOptions.map(option => {
    const optionValue = getOptionValue(option);
    const text = getOptionLabel(option);
    return {
      text,
      value: optionValue
    };
  }).toJS(), [quickReplyOptions]);
  return /*#__PURE__*/_jsx(VizExMobileSelect, {
    options: options,
    onChange: onChange,
    disabled: disabled,
    defaultValue: PLACEHOLDER_VALUE,
    value: value,
    placeholder: placeholder,
    theme: theme
  });
};
QuickReplySelect.displayName = 'QuickReplySelect';
QuickReplySelect.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  quickReplyOptions: PropTypes.instanceOf(OrderedSet).isRequired,
  theme: PropTypes.object,
  value: PropTypes.string
};
export default QuickReplySelect;